import { post } from "../../../../_axios/requisicao";

export function tentarPorCpf(controle: any, etapaCpf: string, etapaAtual: string) {
	if (etapaCpf !== 'inscricao-com-cpf') return false;

	return (
		(etapaAtual === 'cpf')
		|| (controle.solicitacoes && (controle.posicao + 1) >= controle.solicitacoes.length)
	)
}

export async function salvarEscolhaVoluntariado(config: any, dados: any) {
	try {
		const body = { idPerfil: dados.voluntariados, usuarioCadastro: dados.idUsuario || 0 };
		const retorno = await post('api-pessoas', config.urlVoluntariado, body, { referencia: config.referencia });
		return retorno.status === 200;
	} catch (error) {
		return false;
	}
}